import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/insert',
    name: 'insert-form',
    component: () => import('@/views/InsertView.vue')
  },
  {
    path: '/create-table',
    name: 'create-table-form',
    component: () => import('@/views/CreateTableView.vue')
  },
  {
    path: '/update',
    name: 'update-form',
    component: () => import('@/views/UpdateView.vue')
  },
  {
    path: '/delete',
    name: 'delete-form',
    component: () => import('@/views/DeleteView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
